// Thin entry: resolve /config.json FIRST, then load the app graph. Nothing else may be
// statically imported here — a static import would evaluate before the config resolves.
import { loadRuntimeConfig } from "utility/runtime-config";

// The bootstrap chunk can fail to load, e.g. during a deploy that has removed the old hashed
// chunks and serves index.html for the missing file. Sentry starts inside that chunk, so
// log it and leave the user a way out instead of a blank page.
void loadRuntimeConfig()
    .then(() => import("./bootstrap"))
    .catch((error: unknown) => {
        console.error("[bootstrap] the app failed to load:", error);
        const root = document.getElementById("root");
        if (root) {
            root.textContent =
                "The app could not be loaded. It may have just been updated. Please reload the page.";
        }
    });
